//#region Modules
import * as React from "react";
import { AnalyticsContext } from "./-private/AnalyticsContext";
//#endregion

export function useAnalytics() {
  const context = React.useContext(AnalyticsContext);

  if (__DEV__ && context == null) {
    throw new Error("useAnalytics(): It seems it's being call out of <AnalyticsProvider>");
  }

  return context;
}
